import { StyleSheet, Platform } from 'react-native'

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

export default StyleSheet.create({
  container: {
    flex: 1,
  },
  overlayLottie: {
    height: 156,
    width: 156,
  },
  titleStyle: theme => ({
    paddingHorizontal: 17,
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 25,
    color: theme.colors.headerTitleColor,
    paddingTop: 31.4,
    paddingBottom: 29.1,
    lineHeight: 31.2,
  }),
  cardStyle: theme => ({
    marginHorizontal: 17,
    marginBottom: 30,
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    shadowColor: Colors.linegrey,
    elevation: 2,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 4,
    shadowOpacity: 1,
  }),
  dividerStyle: theme => ({
    width: '100%',
    backgroundColor: theme.colors.VFDivider.tertiary,
    height: 1,
    marginBottom: 17,
  }),
  disabledButtonStyle: theme => ({
    backgroundColor: theme.colors.buttons.disabledThree,
  }),
  disabledButtonTextStyle: theme => ({
    color: theme.colors.textButtons.disabled,
  }),
  stepperContainerStyle: {
    justifyContent: 'center',
    alignItems: 'center',
    height: 'auto',
    paddingTop: Platform.OS === 'ios' ? 30 : 20,
  },
  stepperStyle: {
    width: '100%',
    justifyContent: 'center',
    marginBottom: 0,
    marginTop: 0,
    paddingVertical: 15
  },
  buttonStyle: {
    marginHorizontal: 15,
    marginBottom: 16
  },
  errorBackgroundStyle: {
    backgroundColor: 'transparent'
  },
  stepperTitleStyle: {
    fontFamily: Fonts.type.VFFont,
    fontSize: 16.6,
    textAlign: 'center'
  },
  activeTitleTextStyle: {
    ...Fonts.type.bold,
    marginLeft: -1,
  },
})
